module.exports = __webpack_public_path__ + "img/dday-horizontal-scroll.569b34d9.jpg";